var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "850" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c("div", { staticClass: "title" }, [
            _c("b", [
              _vm._v(
                _vm._s(_vm.$ct("to-complete")) +
                  " € " +
                  _vm._s(_vm.bank.TotalDC) +
                  " | "
              ),
              _c(
                "span",
                { class: { ok: _vm.bank.TotalDC == _vm.processedAmount } },
                [
                  _vm._v(
                    _vm._s(_vm.$ct("processed")) +
                      " € " +
                      _vm._s(_vm._f("printHumanFloat")(_vm.processedAmount))
                  ),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "info" }, [
            _vm._v(" " + _vm._s(_vm.bank.Info) + " "),
          ]),
          _vm._l(_vm.batch, function (b, index) {
            return _c(
              "w-row",
              { key: index, attrs: { "no-padding": "" } },
              [
                _vm.hasFavorites
                  ? _c(
                      "w-col",
                      { attrs: { md: "3", sm: "12" } },
                      [
                        _c("app-select-bank-favorite", {
                          attrs: { fancy: "" },
                          on: {
                            input: function ($event) {
                              return _vm.applyFavorite($event, index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "w-col",
                  { attrs: { md: _vm.hasFavorites ? 3 : 4, sm: "12" } },
                  [
                    _c("w-input-number", {
                      attrs: { label: _vm.$ct("amount"), fancy: "" },
                      on: {
                        blur: function ($event) {
                          b.Total = b.TotalDC
                        },
                      },
                      model: {
                        value: b.TotalDC,
                        callback: function ($$v) {
                          _vm.$set(b, "TotalDC", $$v)
                        },
                        expression: "b.TotalDC",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { md: _vm.hasFavorites ? 3 : 4, sm: "12" } },
                  [
                    _c("app-select-bank-kind", {
                      attrs: {
                        label: _vm.$ct("kind"),
                        fancy: "",
                        value: b.Kind,
                      },
                      on: {
                        input: function ($event) {
                          ;(b.Kind = $event), _vm.clearSettings(index)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  {
                    style: {
                      display: "flex",
                      flexDirection: "row",
                      flexGrow: 1,
                    },
                    attrs: { md: _vm.hasFavorites ? 3 : 4, sm: "12" },
                  },
                  [
                    _c(
                      "div",
                      { style: { width: "100%" } },
                      [
                        b.Kind == 1
                          ? _c("app-ledger-account-autocomplete", {
                              attrs: {
                                value: b.LedgerAccountCode,
                                disabled: b.Kind !== 1,
                                fancy: "",
                                label: _vm.$ct("ledger"),
                              },
                              on: {
                                input: function ($event) {
                                  b.LedgerAccountCode = $event
                                },
                              },
                            })
                          : _vm._e(),
                        b.Kind == 2
                          ? _c("app-sale-search", {
                              attrs: {
                                label: _vm.$ct("invoice"),
                                fancy: "",
                                value: b.Invoice,
                                bank: _vm.bank,
                                "compact-search": true,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.selectSale($event, index)
                                },
                              },
                            })
                          : _vm._e(),
                        b.Kind == 3
                          ? _c("app-purchase-search", {
                              attrs: {
                                label: _vm.$ct("invoice"),
                                fancy: "",
                                value: b.Purchase,
                                bank: _vm.bank,
                                "compact-search": true,
                                "show-search-button": false,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.selectPurchase($event, index)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.delete"),
                            expression: "$ct('common.delete')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { flat: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(index)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { style: { display: "block" }, attrs: { sm: "12" } },
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "success",
                      style: { flexGrow: 0 },
                      attrs: {
                        "s:disabled":
                          "Math.abs(bank.TotalDC-processedAmount)<0.01",
                        icon: "plus",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addRule()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("add-rule")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c("w-button", { staticClass: "cancel", on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$ct("common.cancel"))),
          ]),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: {
                disabled:
                  Math.abs(_vm.bank.TotalDC - _vm.processedAmount) >= 0.01,
              },
              on: { click: _vm.confirm },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }